import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "view-container"
}
const _hoisted_2 = { class: "header-section" }
const _hoisted_3 = { class: "chart-main" }
const _hoisted_4 = { class: "chart-container" }
const _hoisted_5 = { class: "chart-container" }
const _hoisted_6 = { class: "chart-container" }
const _hoisted_7 = { class: "chart-container" }
const _hoisted_8 = { class: "chart-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_ArgumentCount = _resolveComponent("ArgumentCount")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_BarChart = _resolveComponent("BarChart")!
  const _component_CircleChart = _resolveComponent("CircleChart")!
  const _component_AlternativesComparison = _resolveComponent("AlternativesComparison")!
  const _component_CrosstabChart = _resolveComponent("CrosstabChart")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_ctx.state.project && _ctx.state.data)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_container, { style: {"max-width":"1600px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_Header, { chartSelectedChart: _ctx.selectedChart }, null, 8, ["chartSelectedChart"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_v_container, {
            fluid: "",
            class: "fill-height chart-layout"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                class: "fill-height chart-row",
                "no-gutters": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "3",
                    md: "2",
                    class: "sidebar"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "sidebar-card",
                        elevation: "2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, { class: "text-h6 d-flex align-center pa-4" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                icon: "mdi-chart-bar",
                                class: "mr-2",
                                color: "primary"
                              }),
                              _cache[0] || (_cache[0] = _createTextVNode(" Charts "))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_divider),
                          _createVNode(_component_v_list, {
                            class: "chart-menu",
                            density: "compact"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.charts, (chart) => {
                                return (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: chart.id,
                                  active: _ctx.selectedChart === chart.id,
                                  onClick: ($event: any) => (_ctx.selectedChart = chart.id),
                                  class: "chart-menu-item"
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      icon: chart.icon,
                                      size: "small",
                                      class: "mr-2"
                                    }, null, 8, ["icon"])
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, { class: "text-caption" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(chart.label), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["active", "onClick"]))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "9",
                    md: "10",
                    class: "content-area"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "content-card",
                        elevation: "2"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_v_card_title, { class: "text-h5 d-flex align-center pa-6 pb-0" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  icon: "mdi-counter",
                                  class: "mr-2",
                                  color: "primary"
                                }),
                                _cache[1] || (_cache[1] = _createTextVNode(" Argument Count "))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_card_text, { class: "pa-6" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ArgumentCount, {
                                  arguments: _ctx.filteredItems,
                                  selectedAlternative: _ctx.state.chartFilters?.selectedAlternative,
                                  analysisPer: _ctx.state.chartFilters?.analysisPer,
                                  alternativesMap: _ctx.state.data?.alternatives || null,
                                  criterionsMap: _ctx.state.data?.criterions || null,
                                  stakeholdersMap: _ctx.state.data?.stakeholders || null
                                }, null, 8, ["arguments", "selectedAlternative", "analysisPer", "alternativesMap", "criterionsMap", "stakeholdersMap"])
                              ]),
                              _: 1
                            })
                          ], 512), [
                            [_vShow, _ctx.selectedChart === 'argument-count']
                          ]),
                          _withDirectives(_createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_v_card_title, { class: "text-h5 d-flex align-center pa-6 pb-0" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  icon: "mdi-chart-bar",
                                  class: "mr-2",
                                  color: "primary"
                                }),
                                _cache[2] || (_cache[2] = _createTextVNode(" Bar Chart of Argument Repartition "))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_card_text, { class: "pa-6" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_BarChart, {
                                  arguments: _ctx.filteredItems,
                                  selectedAlternative: _ctx.state.chartFilters?.selectedAlternative,
                                  analysisPer: _ctx.state.chartFilters?.analysisPer,
                                  selectedCriterion: _ctx.state.chartFilters?.selectedCriterion,
                                  alternativesMap: _ctx.state.data?.alternatives || null,
                                  criterionsMap: _ctx.state.data?.criterions || null,
                                  stakeholdersMap: _ctx.state.data?.stakeholders || null
                                }, null, 8, ["arguments", "selectedAlternative", "analysisPer", "selectedCriterion", "alternativesMap", "criterionsMap", "stakeholdersMap"])
                              ]),
                              _: 1
                            })
                          ], 512), [
                            [_vShow, _ctx.selectedChart === 'bar-chart']
                          ]),
                          _withDirectives(_createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_v_card_title, { class: "text-h5 d-flex align-center pa-6 pb-0" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  icon: "mdi-chart-bubble",
                                  class: "mr-2",
                                  color: "primary"
                                }),
                                _cache[3] || (_cache[3] = _createTextVNode(" Circle Chart of Argument Repartition "))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_card_text, { class: "pa-6" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_CircleChart, {
                                  arguments: _ctx.filteredItems,
                                  criterionsMap: _ctx.state.data?.criterions || null,
                                  selectedCriterion: _ctx.state.chartFilters?.selectedCriterion,
                                  analysisPer: _ctx.state.chartFilters?.analysisPer,
                                  stakeholdersMap: _ctx.state.data?.stakeholders || null,
                                  selectedAlternative: _ctx.state.chartFilters?.selectedAlternative,
                                  alternativesMap: _ctx.state.data?.alternatives || null
                                }, null, 8, ["arguments", "criterionsMap", "selectedCriterion", "analysisPer", "stakeholdersMap", "selectedAlternative", "alternativesMap"])
                              ]),
                              _: 1
                            })
                          ], 512), [
                            [_vShow, _ctx.selectedChart === 'pie-chart']
                          ]),
                          _withDirectives(_createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_v_card_title, { class: "text-h5 d-flex align-center pa-6 pb-0" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  icon: "mdi-compare",
                                  class: "mr-2",
                                  color: "primary"
                                }),
                                _cache[4] || (_cache[4] = _createTextVNode(" Comparison of Alternatives "))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_card_text, { class: "pa-6" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_AlternativesComparison, {
                                  arguments: _ctx.filteredItems,
                                  criterionsMap: _ctx.state.data?.criterions || null,
                                  alternativesMap: _ctx.state.data?.alternatives || null,
                                  stakeholdersMap: _ctx.state.data?.stakeholders || null,
                                  analysisPer: _ctx.state.chartFilters?.analysisPer
                                }, null, 8, ["arguments", "criterionsMap", "alternativesMap", "stakeholdersMap", "analysisPer"])
                              ]),
                              _: 1
                            })
                          ], 512), [
                            [_vShow, _ctx.selectedChart === 'alternatives-comparison']
                          ]),
                          _withDirectives(_createElementVNode("div", _hoisted_8, [
                            _createVNode(_component_v_card_title, { class: "text-h5 d-flex align-center pa-6 pb-0" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  icon: "mdi-table",
                                  class: "mr-2",
                                  color: "primary"
                                }),
                                _cache[5] || (_cache[5] = _createTextVNode(" Cross-tab: Criteria x Stakeholders "))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_card_text, { class: "pa-6" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_CrosstabChart, {
                                  arguments: _ctx.filteredItemsForCrosstab,
                                  criterionsMap: _ctx.state.data?.criterions || null,
                                  stakeholdersMap: _ctx.state.data?.stakeholders || null
                                }, null, 8, ["arguments", "criterionsMap", "stakeholdersMap"])
                              ]),
                              _: 1
                            })
                          ], 512), [
                            [_vShow, _ctx.selectedChart === 'crosstab']
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]))
    : _createCommentVNode("", true)
}